import { createSelector } from "@ngrx/store";

import * as fromAuth from "./auth.reducer";
import { selectAuthState } from "../../root.store";

export const selectLoggedInUser = createSelector(
  selectAuthState,
  (state: fromAuth.AuthStoreState) => state.user
);
